import React from "react";

function UsbDrive() {

    return (
      <svg aria-hidden="true" focusable="false" data-prefix="fad" data-icon="usb-drive" className="svg-inline--fa fa-usb-drive fa-w-20" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><g className="fa-group"><path className="fa-secondary" fill="currentColor" d="M624 128H448v256h176a16 16 0 0 0 16-16V144a16 16 0 0 0-16-16zm-40 184a16 16 0 0 1-16 16h-16a16 16 0 0 1-16-16v-16a16 16 0 0 1 16-16h16a16 16 0 0 1 16 16zm0-96a16 16 0 0 1-16 16h-16a16 16 0 0 1-16-16v-16a16 16 0 0 1 16-16h16a16 16 0 0 1 16 16z" opacity="0.4"></path><path className="fa-primary" fill="currentColor" d="M448 112v288a16 16 0 0 1-16 16H64a64 64 0 0 1-64-64V160a64 64 0 0 1 64-64h368a16 16 0 0 1 16 16z"></path></g></svg>
    );
  }

export default UsbDrive;